"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRLayersComponent = exports.useOL = exports.RContext = void 0;
var react_1 = __importDefault(require("react"));
exports.RContext = react_1.default.createContext({});
function useOL() {
    var context = react_1.default.useContext(exports.RContext);
    return {
        map: context.map,
        layer: context.layer,
        source: context.source,
        vectorlayer: context.vectorlayer,
        vectorsource: context.vectorsource,
        vectortilelayer: context.vectortilelayer,
        feature: context.feature,
        location: context.location,
        style: context.style,
        styleArray: context.styleArray
    };
}
exports.useOL = useOL;
function useRLayersComponent() {
    var context = react_1.default.useContext(exports.RContext);
    return {
        rMap: context.rMap,
        rLayer: context.rLayer,
        rLayerVector: context.rLayerVector,
        rLayerVectorTile: context.rLayerVectorTile,
        rFeature: context.rFeature
    };
}
exports.useRLayersComponent = useRLayersComponent;
//# sourceMappingURL=context.js.map